/**
 * RFC 5424 (Syslog) severity 매핑.
 * 로거 레벨 라벨 → syslog severity(0~7) + 표준 약어.
 * @see https://datatracker.ietf.org/doc/html/rfc5424#section-6.2.1
 */

export interface Rfc5424Severity {
  /** RFC 5424 numeric severity (0=Emergency … 7=Debug) */
  severity: number;
  /** RFC 5424 표준 약어 (emerg/alert/crit/err/warning/notice/info/debug) */
  severityName: string;
}

const SEVERITY_BY_LEVEL: Record<string, Rfc5424Severity> = {
  fatal: { severity: 2, severityName: 'crit' },
  error: { severity: 3, severityName: 'err' },
  warn: { severity: 4, severityName: 'warning' },
  info: { severity: 6, severityName: 'info' },
  debug: { severity: 7, severityName: 'debug' },
  trace: { severity: 7, severityName: 'debug' },
};

const FALLBACK: Rfc5424Severity = { severity: 6, severityName: 'info' };

export function toRfc5424Severity(levelLabel: string): Rfc5424Severity {
  return SEVERITY_BY_LEVEL[levelLabel] ?? FALLBACK;
}
